import React, { useEffect, useRef } from 'react';
import { analytics } from '../hooks/useAnalytics';

export const DEFAULT_PROOF_STATS = [
  { stat: '200+', sub: 'Ivy League placements' },
  { stat: '$38M+', sub: 'in scholarships secured' },
  { stat: '~50', sub: 'high-touch clients per year' },
  { stat: '2 mentors', sub: 'per student — an Ivy student and a career professional' },
];

export function ProofBar({ location = 'unknown', stats = DEFAULT_PROOF_STATS, variant = 'dark' }) {
  const ref = useRef(null);
  const fired = useRef(false);

  useEffect(() => {
    const el = ref.current;
    if (!el || typeof IntersectionObserver === 'undefined') return;
    const obs = new IntersectionObserver((entries) => {
      if (entries[0].isIntersecting && !fired.current) {
        fired.current = true;
        analytics.proofModuleView(location);
        obs.disconnect();
      }
    }, { threshold: 0.4 });
    obs.observe(el);
    return () => obs.disconnect();
  }, [location]);

  const dark = variant === 'dark';
  return (
    <section
      ref={ref}
      className={dark ? 'bg-[#0F392B] py-8 border-b border-[#D4AF37]/20' : 'bg-[#F9F9F7] py-8 border-y border-[#E2E2E2]'}
      data-testid={`proof-bar-${location}`}
    >
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 grid grid-cols-2 md:grid-cols-4 gap-6 text-center md:text-left">
        {stats.map((item, i) => (
          <div key={i} data-testid={`proof-stat-${location}-${i}`}>
            <p className={`text-2xl md:text-3xl font-semibold ${dark ? 'text-[#D4AF37]' : 'text-[#0F392B]'}`} style={{ fontFamily: "'Playfair Display', serif" }}>{item.stat}</p>
            <p className={`text-xs mt-1 leading-relaxed ${dark ? 'text-white/55' : 'text-muted-foreground'}`}>{item.sub}</p>
          </div>
        ))}
      </div>
    </section>
  );
}
